__turbopack_context__.v({
  "attendeesCount": "vUCSJa_attendeesCount",
  "authorInfo": "vUCSJa_authorInfo",
  "avatar": "vUCSJa_avatar",
  "avatarWrapper": "vUCSJa_avatarWrapper",
  "categoryBadge": "vUCSJa_categoryBadge",
  "hidden": "vUCSJa_hidden",
  "iconWrapper": "vUCSJa_iconWrapper",
  "notificationContent": "vUCSJa_notificationContent",
  "notificationDescription": "vUCSJa_notificationDescription",
  "notificationItem": "vUCSJa_notificationItem",
  "notificationTitle": "vUCSJa_notificationTitle",
  "textContent": "vUCSJa_textContent",
  "textSection": "vUCSJa_textSection",
  "unread": "vUCSJa_unread",
  "unreadDot": "vUCSJa_unreadDot",
});
